import { useAppDispatch, useAppSelector } from "app/config/store";
import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { changeStateProduction } from "./in-production-button.reducer";

export const InProductionButton = () => {
  const dispatch = useAppDispatch();

  const inProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const [stateInProduction, setStateInProduction] = useState(true);

  useEffect(() => {
    dispatch(changeStateProduction(inProduction))
  }, [inProduction])

  const changeStateInProduction = () => {
    setStateInProduction(!stateInProduction)
    dispatch(changeStateProduction(stateInProduction))
  }

  return (
    inProduction === false ? (
      <Button outline size="sm" color="info" onClick={() => changeStateInProduction()} className="drawer-not-close">
        Modo {!stateInProduction ? 'DEV' : 'PROD'}
      </Button>
    ) : null
  )
}

export default InProductionButton;
